<template>
  <div class="boss-message-box boss-message-box-received">
    <img
      src="@/assets/images/boss-avatar.svg"
      class="boss-message-box-avatar boss-message-box-avatar-user"
    >
    <div class="boss-message-header-layout">
      <div
        class="boss-layout-block boss-message-when"
        data-test="date"
      >
        {{ date | formatDate }}
      </div>
    </div>
    <div class="boss-layout-block">
      <div
        class="boss-message-mail-subject"
        data-test="subject"
      >
        {{ subject | formatSubject }}
      </div>
      <div
        class="boss-message-mail-body pega-pre-wrap"
        data-test="body"
        v-html="$sanitize(renderBody)"
      />
    </div>
    <div class="boss-message-last-button-block">
      <a
        href="javascript:void(0)"
        class="boss-button"
        data-test="quote-message"
        @click="setBodyAndSubject"
      >メッセージを引用してメールを作成</a>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import dayjs from 'dayjs'
import util from '@/lib/util'

export default {
  filters: {
    formatDate (val) {
      return val ? dayjs(val).format('YYYY/MM/DD(ddd) HH:mm') : ''
    },
    formatSubject (val) {
      return val ? `件名：${val}` : ''
    }
  },
  props: {
    body: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    },
    subject: {
      type: String,
      default: ''
    }
  },
  computed: {
    renderBody () {
      return util.replaceAddressAndUrlLink(this.body)
    }
  },
  methods: {
    setBodyAndSubject () {
      this.$emit('set-body-and-subject', { body: '>' + _.replace(this.body, /\r?\n/g, '\n>'), subject: this.subject })
      this.$scrollTo('#message-register', 0, { offset: -35 })
    }
  }
}
</script>
